<script setup>
  import { ref, onMounted, watch } from 'vue'
  import { usePage } from '@inertiajs/vue3'
  import {trans} from "@/Utils/translation.utils.js";
  import Multiselect from '@vueform/multiselect'
  import Trustpilot from "@/Components/Partials/Trustpilot.vue";
  import LazyLoadComponent from "@/Components/LazyLoadComponent.vue";

  const langList = usePage().props.selectorLanguageData
  const linksList = usePage().props.nav_bar_data.footer
  const selectedLang = ref(null);

  const currentUrl = ref('');

  watch(selectedLang, (newLang, oldLang) => {
      if (typeof window !== 'undefined') {
          if (newLang !== oldLang && typeof oldLang !== 'undefined' && newLang !== currentUrl.value) {
              window.location.href = newLang;
          }
      }
  });

  const paymentIconList = [
    {
      icon: '/img/icons/bitcoin-white.svg',
      alt: 'Bitcoin'
    },
    {
      icon: '/img/icons/visa-white.svg',
      alt: 'Visa'
    },
    {
      icon: '/img/icons/mastercard-white.svg',
      alt: 'Mastercard'
    },
    {
      icon: '/img/icons/amex-white.svg',
      alt: 'Amex'
    },
    {
      icon: '/img/icons/applepay-white.svg',
      alt: 'Apple Pay'
    }
  ]

  const showAsUrl = (url) => {
      return currentUrl.value !== url;
  };

  onMounted(() => {
      if (typeof window !== 'undefined') {
          const url = new URL(window.location.href);
          currentUrl.value = url.href.replace(/\/$/, '');

      }
      selectedLang.value = currentUrl.value
  });

  const currentYear = new Date().getFullYear();

</script>

<template>
  <footer class="main-footer">
    <div class="container">
      <div class="row g-4 mb-4">
        <div class="col-12 col-md-6 col-xl-3">
          <h3>{{ trans('front.footer_h3_our_products') }}</h3>
          <ul v-for="item in linksList.outProducts" class="main-footer__main-list">
            <li>
              <a v-if="showAsUrl(item.link)" :href="item.link || '#'">{{item.title}}</a>
                <span v-else>{{item.title}}</span>
            </li>
          </ul>
            <svg width="0" height="0" class="hidden" style="display: none;">
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-fi">
                <g clip-path="url(#clip0_3292_69519)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M23.8984 10.4348H9.39136H9.39131V0.285217C8.28234 0.531124 7.23098 0.929702 6.26086 1.45906V10.4347V10.4347H0.101578C0.0347813 10.9471 0 11.4695 0 12C0 12.5305 0.0347813 13.0528 0.101578 13.5652H6.26081H6.26086V22.5409C7.23098 23.0702 8.28234 23.4688 9.39131 23.7147V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#0052B4"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69519">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-en">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M11.4783 12H24C24 10.9169 23.8556 9.86768 23.5866 8.86957H11.4783V12Z" fill="#D80027"></path>
                <path d="M11.4783 5.73916H22.2387C21.5041 4.54047 20.5649 3.48095 19.4698 2.6087H11.4783V5.73916Z" fill="#D80027"></path>
                <path d="M11.9998 24C14.824 24 17.4198 23.0239 19.4697 21.3914H4.53003C6.57987 23.0239 9.17567 24 11.9998 24Z" fill="#D80027"></path>
                <path d="M1.76122 18.2609H22.2387C22.8284 17.2986 23.2857 16.2467 23.5865 15.1304H0.41333C0.714127 16.2467 1.17149 17.2986 1.76122 18.2609Z" fill="#D80027"></path>
                <path d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z" fill="#0052B4"></path>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-it">
                <g clip-path="url(#clip0_3292_69533)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M23.9999 12C23.9999 6.84043 20.7434 2.44191 16.1738 0.746399V23.2537C20.7434 21.5581 23.9999 17.1596 23.9999 12Z" fill="#D80027"></path>
                <path d="M0 12C0 17.1596 3.2565 21.5581 7.82611 23.2536V0.746399C3.2565 2.44191 0 6.84043 0 12Z" fill="#6DA544"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69533">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-ko">
                <g clip-path="url(#clip0_3292_71256)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M16.174 12C16.174 13.0435 14.3052 15.6522 12.0001 15.6522C9.69489 15.6522 7.82617 13.0435 7.82617 12C7.82617 9.69478 9.69489 7.82611 12.0001 7.82611C14.3052 7.82611 16.174 9.69478 16.174 12Z" fill="#D80027"></path>
                <path d="M16.174 12C16.174 14.3052 14.3052 16.1739 12.0001 16.1739C9.69489 16.1739 7.82617 14.3052 7.82617 12" fill="#0052B4"></path>
                <path d="M16.4238 15.6895L17.5304 14.5829L18.2682 15.3206L17.1616 16.4272L16.4238 15.6895Z" fill="black"></path>
                <path d="M14.5789 17.5338L15.6855 16.4272L16.4232 17.165L15.3166 18.2716L14.5789 17.5338Z" fill="black"></path>
                <path d="M18.6372 17.9025L19.7438 16.7959L20.4815 17.5337L19.375 18.6403L18.6372 17.9025Z" fill="black"></path>
                <path d="M16.7925 19.7473L17.8991 18.6407L18.6368 19.3784L17.5302 20.485L16.7925 19.7473Z" fill="black"></path>
                <path d="M17.5305 16.7961L18.6371 15.6895L19.3749 16.4272L18.2683 17.5338L17.5305 16.7961Z" fill="black"></path>
                <path d="M15.686 18.6404L16.7926 17.5338L17.5304 18.2716L16.4238 19.3782L15.686 18.6404Z" fill="black"></path>
                <path d="M18.6421 8.31256L15.6911 5.36162L16.4289 4.62388L19.3798 7.57482L18.6421 8.31256Z" fill="black"></path>
                <path d="M15.6907 7.57513L14.5841 6.46854L15.3218 5.73083L16.4284 6.83742L15.6907 7.57513Z" fill="black"></path>
                <path d="M17.5349 9.41992L16.4283 8.31332L17.166 7.57561L18.2726 8.68221L17.5349 9.41992Z" fill="black"></path>
                <path d="M17.9036 5.36157L16.797 4.25497L17.5347 3.51723L18.6413 4.62383L17.9036 5.36157Z" fill="black"></path>
                <path d="M19.749 7.2066L18.6424 6.10001L19.3802 5.36226L20.4868 6.46886L19.749 7.2066Z" fill="black"></path>
                <path d="M4.25415 16.794L7.20509 19.7449L6.46735 20.4827L3.51641 17.5318L4.25415 16.794Z" fill="black"></path>
                <path d="M7.20483 17.5311L8.31143 18.6377L7.57372 19.3754L6.46712 18.2688L7.20483 17.5311Z" fill="black"></path>
                <path d="M5.36035 15.6871L6.46695 16.7937L5.72921 17.5315L4.62261 16.4249L5.36035 15.6871Z" fill="black"></path>
                <path d="M6.46704 14.5803L9.41798 17.5312L8.68024 18.2689L5.7293 15.318L6.46704 14.5803Z" fill="black"></path>
                <path d="M7.20483 4.25269L4.25389 7.20363L3.51615 6.46588L6.46709 3.51494L7.20483 4.25269Z" fill="black"></path>
                <path d="M8.31128 5.35913L5.36034 8.31007L4.62259 7.57233L7.57354 4.62139L8.31128 5.35913Z" fill="black"></path>
                <path d="M9.41895 6.46643L6.468 9.41737L5.73029 8.67966L8.68123 5.72872L9.41895 6.46643Z" fill="black"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71256">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-de">
                <g clip-path="url(#clip0_3292_69526)">
                <path d="M0.746338 16.1739C2.44185 20.7434 6.84037 24 11.9999 24C17.1595 24 21.558 20.7434 23.2536 16.1739L11.9999 15.1304L0.746338 16.1739Z" fill="#FFDA44"></path>
                <path d="M11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611L11.9999 8.86955L23.2536 7.82606C21.558 3.2565 17.1595 0 11.9999 0Z" fill="black"></path>
                <path d="M0.746391 7.82611C0.264047 9.1261 0 10.5322 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739H23.2537C23.736 14.8739 24 13.4678 24 12C24 10.5322 23.736 9.1261 23.2536 7.82611H0.746391Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69526">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-da">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M9.3914 10.4348H23.8985C23.1315 4.54697 18.0969 0 12 0C11.104 0 10.2314 0.0990469 9.39136 0.285234V10.4348H9.3914Z" fill="#D80027"></path>
                <path d="M6.26084 10.4348V1.45911C2.96586 3.25695 0.607016 6.55465 0.101562 10.4348H6.26084V10.4348Z" fill="#D80027"></path>
                <path d="M6.2608 13.5652H0.101562C0.607016 17.4454 2.96586 20.7431 6.26084 22.5409L6.2608 13.5652Z" fill="#D80027"></path>
                <path d="M9.39136 13.5652V23.7147C10.2314 23.9009 11.104 24 12 24C18.0969 24 23.1315 19.453 23.8985 13.5652H9.39136V13.5652Z" fill="#D80027"></path>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-es">
                <g clip-path="url(#clip0_3292_71216)">
                <path d="M0 12C0 13.4679 0.264047 14.8739 0.746391 16.1739L12 17.2174L23.2536 16.1739C23.736 14.8739 24 13.4679 24 12C24 10.5322 23.736 9.12612 23.2536 7.82614L12 6.78265L0.746391 7.82614C0.264047 9.12612 0 10.5322 0 12H0Z" fill="#FFDA44"></path>
                <path d="M23.2536 7.82611C21.558 3.25655 17.1595 0 11.9999 0C6.84037 0 2.44185 3.25655 0.746338 7.82611H23.2536Z" fill="#D80027"></path>
                <path d="M0.746338 16.1739C2.44185 20.7435 6.84037 24 11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71216">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-ne">
                <g clip-path="url(#clip0_3292_71308)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M23.9301 13.305L23.9293 13.304L23.9292 13.305H23.9301Z" fill="#0052B4"></path>
                <path d="M23.9292 13.3043C23.9292 13.3042 23.9293 13.3041 23.9293 13.304L10.7693 0.0623779C10.1757 0.122894 9.59475 0.226675 9.02986 0.370534C3.83897 1.69217 0 12 0 12C0 12 16.7999 23.2423 18.7165 21.9452C19.1 21.6857 19.4677 21.4046 19.8177 21.1036L12.0185 13.3043H23.9292Z" fill="#0052B4"></path>
                <path d="M20.8695 12L9.19898 0.329468C3.92287 1.5912 0 6.33711 0 12C0 18.6274 5.37262 24 12 24C14.5139 24 16.8467 23.2265 18.7748 21.9052L8.86955 12H20.8695Z" fill="#D80027"></path>
                <path d="M11.4128 17.7184L9.94728 17.0291L10.7277 15.6097L9.1363 15.9142L8.93464 14.3065L7.82619 15.4889L6.71774 14.3065L6.51603 15.9142L4.92467 15.6097L5.7051 17.0291L4.2395 17.7184L5.7051 18.4077L4.92467 19.8271L6.51613 19.5227L6.71769 21.1303L7.82619 19.9479L8.93464 21.1303L9.1363 19.5227L10.7277 19.8271L9.94724 18.4078L11.4128 17.7184Z" fill="#F0F0F0"></path>
                <path d="M10.435 6.65545L9.36901 6.15412L9.93662 5.1218L8.77914 5.34323L8.63247 4.17389L7.82626 5.0339L7.02006 4.17389L6.87334 5.34323L5.71586 5.1218L6.28351 6.15412L5.21753 6.65545L7.82626 7.17726L10.435 6.65545Z" fill="#F0F0F0"></path>
                <path d="M10.9567 6.65546C10.9567 8.38435 9.55514 9.78591 7.82625 9.78591C6.09736 9.78591 4.6958 8.38435 4.6958 6.65546" fill="#F0F0F0"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71308">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-ar">
                <g clip-path="url(#clip0_3292_71236)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M6.78271 16.1739L7.8262 23.2537C9.12614 23.7361 10.5322 24 12.0001 24C17.1596 24 21.5582 20.7435 23.2537 16.1739H6.78271Z" fill="black"></path>
                <path d="M6.78271 7.82611L7.8262 0.746297C9.12614 0.263906 10.5322 0 12.0001 0C17.1596 0 21.5582 3.2565 23.2537 7.82611H6.78271Z" fill="#6DA544"></path>
                <path d="M0 12C0 17.1596 3.25655 21.5581 7.82611 23.2536V0.746399C3.25655 2.44191 0 6.84043 0 12Z" fill="#A2001D"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71236">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-fr">
                <g clip-path="url(#clip0_3292_69522)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M23.9999 12C23.9999 6.84043 20.7434 2.44191 16.1738 0.746399V23.2537C20.7434 21.5581 23.9999 17.1596 23.9999 12Z" fill="#D80027"></path>
                <path d="M0 12C0 17.1596 3.25655 21.5581 7.82611 23.2536V0.746399C3.25655 2.44191 0 6.84043 0 12Z" fill="#0052B4"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69522">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-pl">
                <g clip-path="url(#clip0_3292_71289)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71289">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-az">
                <g clip-path="url(#clip0_3292_71293)">
                <path d="M24 12C24 10.5321 23.736 9.12602 23.2536 7.82609L12 7.30432L0.746391 7.82604C0.264047 9.12602 0 10.5321 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12Z" fill="#D80027"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z" fill="#6DA544"></path>
                <path d="M0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611Z" fill="#338AF3"></path>
                <path d="M12.2609 15.3913C10.388 15.3913 8.86964 13.8729 8.86964 12C8.86964 10.127 10.388 8.60867 12.2609 8.60867C12.8449 8.60867 13.3944 8.75633 13.8742 9.0163C13.1215 8.28032 12.0923 7.82605 10.9566 7.82605C8.65139 7.82605 6.78271 9.69477 6.78271 11.9999C6.78271 14.3051 8.65143 16.1738 10.9566 16.1738C12.0924 16.1738 13.1216 15.7196 13.8742 14.9836C13.3944 15.2436 12.8449 15.3913 12.2609 15.3913Z" fill="#F0F0F0"></path>
                <path d="M14.8696 9.65216L15.3188 10.9155L16.5297 10.3398L15.9541 11.5507L17.2174 12L15.9541 12.4492L16.5297 13.6602L15.3188 13.0845L14.8696 14.3478L14.4204 13.0845L13.2094 13.6602L13.7851 12.4492L12.5217 12L13.7851 11.5507L13.2094 10.3398L14.4204 10.9155L14.8696 9.65216Z" fill="#F0F0F0"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71293">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-fa">
                <g clip-path="url(#clip0_3292_71246)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M15.8976 8.86955H14.3275C14.3405 9.0421 14.3479 9.21619 14.3479 9.39127C14.3479 10.5521 14.0577 11.6772 13.5519 12.4781C13.3958 12.7252 13.1336 13.074 12.7826 13.3093V8.86951H11.2174V13.3093C10.8665 13.074 10.6042 12.7252 10.4481 12.4781C9.94227 11.6772 9.65216 10.5521 9.65216 9.39127C9.65216 9.21619 9.65957 9.04205 9.67251 8.86955H8.10248C8.0924 9.04126 8.08691 9.21516 8.08691 9.39127C8.08691 12.6095 9.80573 15.1304 11.9999 15.1304C14.1942 15.1304 15.913 12.6095 15.913 9.39127C15.9131 9.21516 15.9076 9.04126 15.8976 8.86955Z" fill="#D80027"></path>
                <path d="M4.95647 5.73914H6.52167V6.78263H8.08688V5.73914H9.65208V6.78263H11.2173V5.73914H12.7825V6.78263H14.3477V5.73914H15.9129V6.78263H17.4781V5.73914H19.0433V6.78263H22.8091C20.8682 2.76867 16.7574 0 12 0C7.24247 0 3.13167 2.76867 1.19067 6.78263H4.95647V5.73914Z" fill="#6DA544"></path>
                <path d="M19.0434 17.2173V18.2608H17.4782V17.2173H15.913V18.2608H14.3478V17.2173H12.7826V18.2608H11.2174V17.2173H9.65222V18.2608H8.08702V17.2173H6.52167V18.2608H4.95647V17.2173H1.19067C3.13167 21.2313 7.24242 24 12 24C16.7575 24 20.8682 21.2313 22.8092 17.2173H19.0434Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71246">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-hr">
                <g clip-path="url(#clip0_3292_71374)">
                <path d="M24 12C24 10.5321 23.736 9.12602 23.2536 7.82609L12 7.30432L0.746391 7.82604C0.264047 9.12602 0 10.5321 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12Z" fill="#F0F0F0"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z" fill="#0052B4"></path>
                <path d="M0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611Z" fill="#D80027"></path>
                <path d="M15.1304 8.3479H13.0435L13.3913 5.73916L14.7826 4.69568L16.1739 5.73916V7.82613L15.1304 8.3479Z" fill="#338AF3"></path>
                <path d="M8.86961 8.3479H10.9566L10.6087 5.73916L9.21742 4.69568L7.82617 5.73916V7.82613L8.86961 8.3479Z" fill="#338AF3"></path>
                <path d="M13.3913 8.3479H10.6086V5.73916L12 4.69568L13.3913 5.73916V8.3479Z" fill="#0052B4"></path>
                <path d="M7.82617 7.82617V13.5653C7.82617 14.9318 8.48627 16.1471 9.50439 16.909L10.2348 16.7262L11.1566 17.6535C11.4292 17.7096 11.7112 17.7392 12.0001 17.7392C12.2875 17.7392 12.5681 17.71 12.8392 17.6544L13.8914 16.7783L14.4957 16.9073C15.5134 16.1455 16.174 14.9314 16.174 13.5653V7.82617H7.82617Z" fill="#F0F0F0"></path>
                <path d="M7.82617 7.82611H9.49572V9.49566H7.82617V7.82611Z" fill="#D80027"></path>
                <path d="M11.1653 7.82611H12.8348V9.49566H11.1653V7.82611Z" fill="#D80027"></path>
                <path d="M14.5044 7.82611H16.1739V9.49566H14.5044V7.82611Z" fill="#D80027"></path>
                <path d="M9.49561 9.49567H11.1652V11.1652H9.49561V9.49567Z" fill="#D80027"></path>
                <path d="M12.835 9.49567H14.5045V11.1652H12.835V9.49567Z" fill="#D80027"></path>
                <path d="M7.82617 11.1647H9.49572V12.8342H7.82617V11.1647Z" fill="#D80027"></path>
                <path d="M9.49561 12.8343H11.1652V14.5038H9.49561V12.8343Z" fill="#D80027"></path>
                <path d="M11.1653 11.1647H12.8348V12.8342H11.1653V11.1647Z" fill="#D80027"></path>
                <path d="M14.5044 11.1647H16.1739V12.8342H14.5044V11.1647Z" fill="#D80027"></path>
                <path d="M12.835 12.8343H14.5045V14.5038H12.835V12.8343Z" fill="#D80027"></path>
                <path d="M11.1653 14.5038H12.8348V16.1734H11.1653V14.5038Z" fill="#D80027"></path>
                <path d="M9.49567 14.504H7.93384C8.07709 15.1246 8.35871 15.6925 8.74487 16.1735H9.49567V14.504Z" fill="#D80027"></path>
                <path d="M14.5044 16.1736H15.2551C15.6414 15.6925 15.9229 15.1246 16.0662 14.504H14.5044V16.1736Z" fill="#D80027"></path>
                <path d="M9.49561 16.1736V16.9021C9.98118 17.2675 10.5487 17.5294 11.1652 17.6552V16.1736H9.49561Z" fill="#D80027"></path>
                <path d="M12.835 16.1736V17.6552C13.4515 17.5295 14.0189 17.2675 14.5045 16.9021V16.1736H12.835Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71374">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-el">
                <g clip-path="url(#clip0_3292_71319)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M12 8.86953H23.5866C23.2857 7.75325 22.8284 6.70132 22.2387 5.73907H12V8.86953Z" fill="#338AF3"></path>
                <path d="M4.53009 21.3913H19.4698C20.5649 20.5191 21.5041 19.4596 22.2386 18.2609H1.76123C2.49581 19.4596 3.435 20.5191 4.53009 21.3913Z" fill="#338AF3"></path>
                <path d="M4.17384 2.90338C3.23043 3.71577 2.41486 4.67244 1.76123 5.73913H4.17384V2.90338Z" fill="#338AF3"></path>
                <path d="M12 12C12 10.7777 12 9.75476 12 8.86957H7.30434V12H4.17389V8.86957H0.413391C0.144375 9.86772 0 10.9169 0 12C0 13.0832 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0832 24 12H12Z" fill="#338AF3"></path>
                <path d="M12.0001 0C10.3337 0 8.74679 0.339984 7.30444 0.953812V5.73914H12.0001C12.0001 4.64639 12.0001 3.717 12.0001 2.60869H19.47C17.4201 0.976125 14.8243 0 12.0001 0Z" fill="#338AF3"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71319">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-id">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#A2001D"></path>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-hu">
                <g clip-path="url(#clip0_3292_71328)">
                <path d="M0.746391 7.82614C0.264047 9.12617 0 10.5322 0 12C0 13.4679 0.264047 14.874 0.746391 16.1739L12 17.2174L23.2536 16.1739C23.736 14.874 24 13.4679 24 12C24 10.5322 23.736 9.12617 23.2536 7.82614L12 6.78265L0.746391 7.82614Z" fill="#F0F0F0"></path>
                <path d="M11.9999 0C6.84037 0 2.44181 3.2565 0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0Z" fill="#D80027"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44181 20.7435 6.84037 24 11.9999 24Z" fill="#6DA544"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71328">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-ja">
                <g clip-path="url(#clip0_3292_71242)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M12.0001 17.2174C14.8816 17.2174 17.2175 14.8815 17.2175 12C17.2175 9.11855 14.8816 6.78265 12.0001 6.78265C9.11861 6.78265 6.78271 9.11855 6.78271 12C6.78271 14.8815 9.11861 17.2174 12.0001 17.2174Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71242">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-ka">
                <g clip-path="url(#clip0_3292_71409)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"></path>
                <path d="M7.30428 5.73914V4.17389H5.73908V5.73914H4.17383V7.30434H5.73908V8.86954H7.30428V7.30434H8.86948V5.73914H7.30428Z" fill="#D80027"></path>
                <path d="M18.2608 5.73914V4.17389H16.6956V5.73914H15.1304V7.30434H16.6956V8.86954H18.2608V7.30434H19.826V5.73914H18.2608Z" fill="#D80027"></path>
                <path d="M7.30428 16.6956V15.1304H5.73908V16.6956H4.17383V18.2608H5.73908V19.8261H7.30428V18.2608H8.86948V16.6956H7.30428Z" fill="#D80027"></path>
                <path d="M18.2608 16.6956V15.1304H16.6956V16.6956H15.1304V18.2608H16.6956V19.8261H18.2608V18.2608H19.826V16.6956H18.2608Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71409">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-lt">
                <g clip-path="url(#clip0_3292_71418)">
                <path d="M23.2536 16.1739C23.736 14.874 24 13.4679 24 12C24 10.5322 23.736 9.12608 23.2536 7.82614L12 6.78265L0.746391 7.82614C0.264 9.12608 0 10.5322 0 12C0 13.4679 0.264 14.874 0.746391 16.1739L12 17.2174L23.2536 16.1739Z" fill="#6DA544"></path>
                <path d="M23.2536 7.82611C21.558 3.2565 17.1595 0 11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611H23.2536Z" fill="#FFDA44"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71418">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-nl">
                <g clip-path="url(#clip0_3292_69537)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0Z" fill="#A2001D"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z" fill="#0052B4"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69537">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-pt">
                <g clip-path="url(#clip0_3292_69549)">
                <path d="M0 12C0 17.1595 3.2565 21.5581 7.82602 23.2536L8.86955 12L7.82602 0.746399C3.2565 2.44196 0 6.84043 0 12Z" fill="#6DA544"></path>
                <path d="M23.9999 12C23.9999 5.37262 18.6273 0 11.9999 0C10.5321 0 9.12596 0.264047 7.82593 0.746391V23.2536C9.12596 23.736 10.5321 24 11.9999 24C18.6273 24 23.9999 18.6274 23.9999 12Z" fill="#D80027"></path>
                <path d="M7.82599 16.1739C10.1312 16.1739 11.9999 14.3052 11.9999 12C11.9999 9.69483 10.1312 7.82611 7.82599 7.82611C5.52081 7.82611 3.6521 9.69483 3.6521 12C3.6521 14.3052 5.52081 16.1739 7.82599 16.1739Z" fill="#FFDA44"></path>
                <path d="M5.47827 9.91302V12.5217C5.47827 13.8184 6.5294 14.8695 7.8261 14.8695C9.1228 14.8695 10.1739 13.8184 10.1739 12.5217V9.91302H5.47827Z" fill="#D80027"></path>
                <path d="M7.82608 13.3043C7.39455 13.3043 7.04346 12.9532 7.04346 12.5217V11.4783H8.60866V12.5218C8.60866 12.9532 8.25757 13.3043 7.82608 13.3043Z" fill="#F0F0F0"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69549">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-sv">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path>
                <path d="M9.3914 10.4348H23.8985C23.1315 4.54697 18.0969 0 12 0C11.1041 0 10.2313 0.0990469 9.39136 0.285234V10.4348H9.3914Z" fill="#0052B4"></path>
                <path d="M6.26084 10.4348V1.45911C2.96581 3.25695 0.607016 6.55465 0.101562 10.4348H6.26084V10.4348Z" fill="#0052B4"></path>
                <path d="M6.2608 13.5652H0.101562C0.607016 17.4454 2.96581 20.7431 6.26084 22.5409L6.2608 13.5652Z" fill="#0052B4"></path>
                <path d="M9.39136 13.5652V23.7147C10.2313 23.9009 11.1041 24 12 24C18.0969 24 23.1315 19.453 23.8985 13.5652H9.39136V13.5652Z" fill="#0052B4"></path>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-no">
                <g clip-path="url(#clip0_3292_69541)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M0.41333 15.1304C1.10764 17.7066 2.63788 19.9395 4.6956 21.5205V15.1304H0.41333Z" fill="#D80027"></path>
                <path d="M10.9565 23.9543C11.3005 23.9839 11.6484 24 12 24C17.5444 24 22.2096 20.2396 23.5866 15.1304H10.9565V23.9543Z" fill="#D80027"></path>
                <path d="M23.5866 8.86955C22.2096 3.76036 17.5444 0 12 0C11.6484 0 11.3005 0.0160312 10.9565 0.0456562V8.86955H23.5866Z" fill="#D80027"></path>
                <path d="M4.6956 2.47943C2.63788 4.06052 1.10764 6.29332 0.41333 8.86952H4.6956V2.47943Z" fill="#D80027"></path>
                <path d="M23.8984 10.4348H9.39136H9.39131V0.285217C8.28234 0.531124 7.23098 0.929702 6.26086 1.45906V10.4347V10.4347H0.101578C0.0347813 10.9471 0 11.4695 0 12C0 12.5305 0.0347813 13.0528 0.101578 13.5652H6.26081H6.26086V22.5409C7.23098 23.0702 8.28234 23.4688 9.39131 23.7147V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#0052B4"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69541">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-ru">
                <g clip-path="url(#clip0_3292_69555)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M23.2536 16.1739C23.736 14.8739 24 13.4678 24 12C24 10.5322 23.736 9.1261 23.2536 7.82611H0.746391C0.264047 9.1261 0 10.5322 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 17.2174L23.2536 16.1739Z" fill="#0052B4"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69555">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-sk">
                <g clip-path="url(#clip0_3292_71400)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 10.5322 23.736 9.12605 23.2536 7.82611H0.746391C0.264047 9.12605 0 10.5322 0 12C0 18.6274 5.37262 24 12 24Z" fill="#0052B4"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z" fill="#D80027"></path>
                <path d="M3.10303 6.78265V12.7689C3.10303 16.1741 7.55151 17.2175 7.55151 17.2175C7.55151 17.2175 11.9999 16.1741 11.9999 12.7689V6.78265H3.10303Z" fill="#F0F0F0"></path>
                <path d="M4.14648 6.78265V12.7689C4.14648 13.1686 4.23527 13.5462 4.41114 13.9001H10.6918C10.8677 13.5462 10.9564 13.1686 10.9564 12.7689V6.78265H4.14648Z" fill="#D80027"></path>
                <path d="M9.63849 10.9565H8.07333V9.91303H9.11682V8.86955H8.07333V7.82611H7.02985V8.86955H5.98641V9.91303H7.02985V10.9565H5.4646V12H7.02985V13.0435H8.07333V12H9.63849V10.9565Z" fill="#F0F0F0"></path>
                <path d="M5.83464 15.3567C6.50706 15.7793 7.19791 16.0247 7.55158 16.1338C7.90525 16.0247 8.5961 15.7793 9.26852 15.3567C9.94661 14.9306 10.422 14.4431 10.6919 13.9001C10.3942 13.6895 10.0309 13.5653 9.63855 13.5653C9.49567 13.5653 9.35688 13.5822 9.22342 13.6133C8.94063 12.9707 8.29867 12.5218 7.55163 12.5218C6.80458 12.5218 6.16258 12.9707 5.87983 13.6133C5.74638 13.5822 5.60753 13.5653 5.46471 13.5653C5.07231 13.5653 4.70908 13.6895 4.41138 13.9001C4.68114 14.4431 5.1565 14.9305 5.83464 15.3567Z" fill="#0052B4"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71400">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-sq">
                <g clip-path="url(#clip0_3292_71365)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path>
                <path d="M18.7827 8.90669H14.4362C14.7045 8.62572 14.8697 8.24533 14.8697 7.82613C14.8697 6.96171 14.1689 6.26093 13.3045 6.26093C12.7599 6.26093 12.2805 6.53918 12.0001 6.9611C11.7197 6.53918 11.2403 6.26093 10.6958 6.26093C9.83134 6.26093 9.13056 6.96171 9.13056 7.82613C9.13056 8.24533 9.2957 8.62577 9.56401 8.90669H5.21753C5.21753 10.0593 6.22145 10.9936 7.37397 10.9936H7.3044C7.3044 12.1463 8.23876 13.0806 9.39142 13.0806C9.39142 13.4539 9.48981 13.8039 9.66156 14.1069L7.93047 15.838L9.25862 17.1661L11.1426 15.2822C11.2164 15.3092 11.2928 15.3309 11.3716 15.3457L10.2332 17.9161L12.0001 19.8261L13.7671 17.916L12.6286 15.3456C12.7075 15.3308 12.7838 15.3092 12.8576 15.2821L14.7416 17.166L16.0697 15.8379L14.3386 14.1068C14.5104 13.8038 14.6088 13.4538 14.6088 13.0805C15.7614 13.0805 16.6958 12.1462 16.6958 10.9935H16.6262C17.7788 10.9936 18.7827 10.0593 18.7827 8.90669Z" fill="black"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71365">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-sr">
                <g clip-path="url(#clip0_3292_71354)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z" fill="#0052B4"></path>
                <path d="M11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0Z" fill="#D80027"></path>
                <path d="M3.10303 6.78265V12.7689C3.10303 16.1741 7.55151 17.2175 7.55151 17.2175C7.55151 17.2175 11.9999 16.1741 11.9999 12.7689V6.78265H3.10303Z" fill="#D80027"></path>
                <path d="M4.94263 7.82613H10.16V5.73916L9.11657 6.26088L7.55136 4.69568L5.98611 6.26088L4.94263 5.73916V7.82613Z" fill="#FFDA44"></path>
                <path d="M10.9565 13.6024L7.56514 10.2111L4.17383 13.6024L5.28059 14.7091L7.56514 12.4246L9.84969 14.7091L10.9565 13.6024Z" fill="#FFDA44"></path>
                <path d="M10.9565 10.4348H9.37414C9.46311 10.2812 9.51486 10.1034 9.51486 9.91317C9.51486 9.3368 9.04766 8.86969 8.47137 8.86969C8.07317 8.86969 7.72738 9.09272 7.55145 9.42061C7.37553 9.09277 7.02973 8.86969 6.63153 8.86969C6.05525 8.86969 5.58805 9.3368 5.58805 9.91317C5.58805 10.1034 5.6398 10.2813 5.72877 10.4348H4.17383C4.17383 11.0111 4.67581 11.4783 5.25205 11.4783H5.21731C5.21731 12.0546 5.68447 12.5218 6.2608 12.5218C6.2608 13.032 6.62727 13.456 7.11125 13.5467L6.28906 15.4031C6.68309 15.5633 7.11369 15.6522 7.56519 15.6522C8.01669 15.6522 8.44728 15.5633 8.84131 15.4031L8.01913 13.5467C8.50311 13.4561 8.86958 13.0321 8.86958 12.5218C9.44591 12.5218 9.91306 12.0546 9.91306 11.4783H9.87833C10.4545 11.4783 10.9565 11.0111 10.9565 10.4348Z" fill="#F0F0F0"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71354">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-et">
                <g clip-path="url(#clip0_3292_71428)">
                <path d="M0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12C24 10.5321 23.736 9.12607 23.2536 7.82609L12 7.30432L0.746391 7.82604C0.264047 9.12607 0 10.5321 0 12H0Z" fill="black"></path>
                <path d="M11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0Z" fill="#0052B4"></path>
                <path d="M23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739Z" fill="#F0F0F0"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71428">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-tl">
                <g clip-path="url(#clip0_3292_71279)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M12 0V12L3.51465 20.4853C5.68623 22.6568 8.68623 24 12 24C18.6273 24 24 18.6274 24 12C24 5.37262 12 0 12 0Z" fill="#D80027"></path>
                <path d="M12 0C8.68623 0 5.68623 1.34316 3.51465 3.51469C6.45887 6.45891 7.50404 7.50412 12 12H24C24 5.37262 18.6273 0 12 0Z" fill="#0052B4"></path>
                <path d="M8.21674 12L6.75124 11.3107L7.53166 9.89135L5.94025 10.1958L5.7386 8.58813L4.6301 9.77051L3.52164 8.58813L3.31994 10.1958L1.72858 9.89131L2.509 11.3107L1.04346 12L2.509 12.6894L1.72858 14.1087L3.32008 13.8043L3.5216 15.4119L4.6301 14.2295L5.7386 15.4119L5.94025 13.8043L7.53157 14.1087L6.75119 12.6894L8.21674 12Z" fill="#FFDA44"></path>
                <path d="M3.20033 4.69568L3.68802 5.37738L4.487 5.1243L3.98928 5.79874L4.47697 6.48044L3.68169 6.21555L3.18402 6.88994L3.19025 6.05182L2.39502 5.78688L3.19414 5.5338L3.20033 4.69568Z" fill="#FFDA44"></path>
                <path d="M3.20033 17.1101L3.68802 17.7918L4.487 17.5387L3.98928 18.2132L4.47697 18.8949L3.68169 18.63L3.18402 19.3044L3.19025 18.4662L2.39502 18.2013L3.19414 17.9482L3.20033 17.1101Z" fill="#FFDA44"></path>
                <path d="M10.1563 10.9029L9.66866 11.5846L8.86963 11.3314L9.36735 12.0059L8.87966 12.6877L9.67494 12.4227L10.1727 13.0971L10.1664 12.259L10.9616 11.9941L10.1625 11.741L10.1563 10.9029Z" fill="#FFDA44"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71279">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-tr">
                <g clip-path="url(#clip0_3292_69566)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path>
                <path d="M11.5085 9.8056L12.4931 11.1624L14.0876 10.6454L13.1015 12.001L14.0859 13.3577L12.492 12.8387L11.5058 14.1944L11.5069 12.5181L9.91284 11.9991L11.5074 11.482L11.5085 9.8056Z" fill="#F0F0F0"></path>
                <path d="M8.8215 15.3913C6.94856 15.3913 5.43018 13.8729 5.43018 12C5.43018 10.127 6.94856 8.60867 8.8215 8.60867C9.40547 8.60867 9.95493 8.75638 10.4347 9.0163C9.68207 8.28027 8.65284 7.82605 7.51715 7.82605C5.21193 7.82605 3.34326 9.69477 3.34326 11.9999C3.34326 14.3051 5.21198 16.1738 7.51715 16.1738C8.65293 16.1738 9.68212 15.7196 10.4347 14.9836C9.95493 15.2436 9.40547 15.3913 8.8215 15.3913Z" fill="#F0F0F0"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_69566">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-bg">
                <g clip-path="url(#clip0_3292_71369)">
                <path d="M24 12C24 10.5321 23.736 9.12602 23.2536 7.82609L12 7.30432L0.746391 7.82604C0.264047 9.12602 0 10.5321 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12Z" fill="#496E2D"></path>
                <path d="M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z" fill="#D80027"></path>
                <path d="M0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611Z" fill="#F0F0F0"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71369">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-th">
                <g clip-path="url(#clip0_3292_71301)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M23.2536 7.82611H0.746391C0.264 9.1261 0 10.5322 0 12C0 13.4678 0.264 14.8739 0.746391 16.1739H23.2537C23.736 14.8739 24 13.4678 24 12C24 10.5322 23.736 9.1261 23.2536 7.82611Z" fill="#0052B4"></path>
                <path d="M11.9999 0C8.36285 0 5.10396 1.61831 2.90332 4.17389H21.0965C18.8959 1.61831 15.637 0 11.9999 0Z" fill="#D80027"></path>
                <path d="M21.0965 19.8261H2.90332C5.10396 22.3817 8.36285 24 11.9999 24C15.637 24 18.8959 22.3817 21.0965 19.8261Z" fill="#D80027"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71301">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-vi">
                <g clip-path="url(#clip0_3292_71252)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path>
                <path d="M12 6.26086L13.2951 10.2466H17.486L14.0954 12.7099L15.3905 16.6957L12 14.2323L8.60957 16.6957L9.90463 12.7099L6.51416 10.2466H10.705L12 6.26086Z" fill="#FFDA44"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71252">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-ro">
                <g clip-path="url(#clip0_3292_71222)">
                <path d="M16.174 0.746344C14.8739 0.264047 13.4679 6.23894e-09 12.0001 6.23894e-09C10.5322 -4.68688e-05 9.12618 0.264047 7.8262 0.746344L6.78271 12L7.8262 23.2536C9.12614 23.736 10.5322 24 12.0001 24C13.4679 24 14.874 23.736 16.174 23.2536L17.2174 12L16.174 0.746344Z" fill="#FFDA44"></path>
                <path d="M23.9999 12C23.9999 6.84048 20.7434 2.44187 16.1738 0.746399V23.2537C20.7434 21.5581 23.9999 17.1596 23.9999 12Z" fill="#D80027"></path>
                <path d="M0 12C0 17.1596 3.2565 21.5581 7.82602 23.2537L7.82606 0.74646C3.2565 2.44193 0 6.8404 0 12H0Z" fill="#0052B4"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71222">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-uk">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path>
                <path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#338AF3"></path>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-cs">
                <g clip-path="url(#clip0_3292_71338)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path>
                <path d="M10.9565 12C10.9565 12 3.52168 20.487 3.51465 20.4853C5.68618 22.6568 8.68623 24 12 24C18.6273 24 24 18.6274 24 12H10.9565Z" fill="#D80027"></path>
                <path d="M3.51471 3.51471C-1.17157 8.20099 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51471Z" fill="#0052B4"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71338">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="flag-zh">
                <g clip-path="url(#clip0_3292_71227)">
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path>
                <path d="M6.56719 7.3031L7.60312 10.4906H10.9547L8.24531 12.464L9.28125 15.6515L6.56719 13.6828L3.85313 15.6515L4.89375 12.464L2.17969 10.4906H5.53125L6.56719 7.3031Z" fill="#FFDA44"></path>
                <path d="M14.2265 18.5859L13.4343 17.6109L12.2624 18.0656L12.9421 17.0109L12.1499 16.0312L13.364 16.3547L14.0483 15.3L14.114 16.5562L15.3327 16.8797L14.1562 17.3297L14.2265 18.5859Z" fill="#FFDA44"></path>
                <path d="M15.8015 15.7266L16.1765 14.5266L15.1499 13.8L16.4062 13.7812L16.7765 12.5812L17.1843 13.7719L18.4405 13.7578L17.4327 14.5078L17.8358 15.6984L16.8093 14.9719L15.8015 15.7266Z" fill="#FFDA44"></path>
                <path d="M17.9251 8.80778L17.372 9.93746L18.272 10.814L17.0298 10.6359L16.4767 11.7609L16.261 10.5234L15.0142 10.3453L16.1298 9.75934L15.9142 8.51715L16.8142 9.39371L17.9251 8.80778Z" fill="#FFDA44"></path>
                <path d="M14.2594 5.38593L14.1657 6.63749L15.3329 7.11093L14.1094 7.41093L14.0204 8.66718L13.3594 7.59843L12.136 7.89843L12.9469 6.93749L12.2813 5.87343L13.4485 6.34686L14.2594 5.38593Z" fill="#FFDA44"></path>
                </g>
                <defs>
                <clipPath id="clip0_3292_71227">
                    <rect width="24" height="24" fill="white"></rect>
                </clipPath>
                </defs>
            </symbol>
            </svg>
          <LazyLoadComponent>
              <Multiselect v-model="selectedLang" :options="langList" :can-clear="false" open-direction="top">
                <template v-slot:singlelabel="{ value }">
                  <div class="multiselect-single-label">
                    <svg class="character-label-icon me-2" style="width: 24px; height: 24px;">
                        <use :xlink:href="`#flag-${value.locale}`"></use>
                    </svg>
                    {{ value.name }}
                  </div>
                </template>

                <template v-slot:option="{ option }">
                    <svg class="character-label-icon me-2" style="width: 24px; height: 24px;">
                        <use :xlink:href="`#flag-${option.locale}`"></use>
                    </svg>
                  {{ option.name }}
                </template>
              </Multiselect>
          </LazyLoadComponent>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <h3>{{ trans('front.footer_h3_support_information') }}</h3>
          <p>{{ trans('front.footer_text_support_information') }}</p>
            <ul v-for="item in linksList.info">
              <li class="mb-3">
                <a v-if="showAsUrl(item.link)" :href="item.link || '#'">
                    {{item.title}}
                </a>
                <span v-else>{{item.title}}</span>
              </li>
            </ul>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <h3>{{ trans('front.footer_h3_contacts') }}</h3>
          <p>{{ trans('front.footer_text_contacts') }}
              <a v-if="showAsUrl(linksList.contacts)" class="text-decoration-underline" :href="linksList.contacts || '#'">
                  {{trans('front.footer_text_contacts_link') }}
              </a>
              <span v-else class="text-decoration-underline">{{trans('front.footer_text_contacts_link') }}</span>
          </p>
          <div class="d-flex mt-5">
            <img class="me-3" src="/img/icons/location.svg" alt="Location" width="40" height="40" loading="lazy" />
            <p>
              Vipsocmedia SRL <br />
              București, Sector 3 Mihai Bravu Nr 255 Subsol Modul S146
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <div class="main-footer__moneyback">
            <img src="/img/icons/moneyback-footer.svg" alt="Moneyback" width="112" height="112" loading="lazy"/>
            <span>{{ trans('front.footer_text_money_back') }}</span>
          </div>
          <div class="main-footer__payment d-flex align-items-center">
            <img
              v-for="item in paymentIconList"
              :key="item.alt"
              class="me-2"
              :src="item.icon"
              :alt="item.alt"
              width="50"
              height="31"
              loading="lazy"
            />
          </div>
            <Trustpilot/>
        </div>
      </div>
      <p class="text-center">
          {{ trans('front.footer_text_intro') }}
      </p>
      <div class="main-footer__copyrights">Viplikes © Copyright. 2013-{{currentYear}} {{ trans('front.footer_text_all_rights_reserved') }}</div>
    </div>

  </footer>
</template>

<style lang="scss">
  .main-footer {
    background-color: #2d4472;
    padding: 3rem 0 2rem;
    color: #fff;

    h3 {
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1;
      margin-bottom: 1.25rem;
    }

    a {
      color: #fff;
    }

    &__main-list {
      font-size: 1.25rem;
      margin-bottom: 1.25rem;

      li {
        margin-bottom: 0.75rem;
      }
    }

    &__moneyback {
      position: relative;
      margin-bottom: 2rem;

      img {
        position: relative;
        z-index: 5;
      }

      span {
        position: absolute;
        z-index: 4;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        padding: 0.8125rem 1rem;
        padding-left: 8.125rem;
        background-color: #253b65;
        border-radius: 2.0625rem;
        font-weight: 700;
      }
    }

    &__payment {
      margin-bottom: 2rem;
    }

    &__copyrights {
      font-size: 1.25rem;
      text-align: center;
    }

    .multiselect {
      background-color: #253b65;
      border: none;
      border-radius: 0.5rem;

      &.is-open {
        border-radius: 0.5rem;
      }

      &.is-active {
        box-shadow: none;
      }
    }

    .multiselect-caret {
      display: none;
    }

    .multiselect-dropdown {
      border: 0.0625rem solid #c8d4e0;
      border-radius: 0.5rem;
      box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.075);
      overflow: hidden;
    }

    .multiselect-options {
      padding: 0.5rem;
      overflow: auto;
    }

    .multiselect-option {
      color: #2d4472;
      padding: 0.5rem;

      &.is-selected {
        background: #f5f5f5;
        color: #2d4472;
      }
    }
  }
</style>
